import { addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import { DataProps } from '../../components/homepage/types';
import { IProducts } from '../../types/product/productDetailPage';

const Event = {
  eec: 'gaEvent',
};

const Actions = {
  click: 'click',
  view: 'view',
};

// GA3
export const dispatchDataLayerEventOnClick = (data: DataProps) => {
  const { item, position } = data;
  addDataLayerEntry(Event.eec, {
    gaEvent: {
      eventCategory: item,
      eventLabel: position,
      eventAction: Actions.click,
      eventNonInteraction: true,
    },
  });
};

export const dispatchDataLayerEventOnProductsClickGA4 = (data: {
  eventName: string;
  position: number;
  productName: string;
  placementId?: string, // In case if recommendations are shown
}) => {
  const {
    eventName, position, productName, placementId,
  } = data;
  addDataLayerEntry(
    eventName,
    {
      position,
      productName,
      recommendation_id: placementId,
      content_type: 'non-personalized',
      audience_type: 'non-recognized',
    },
  );
};

export const dispatchDataLayerHomepageProductImpressionsGA = (
  impressions: IProducts[],
  productListName = '',
) => {
  const eventName = 'view_item_list';
  const items = impressions?.map((product) => {
    const {
      itemName = '', itemId = '', itemCategory = '', itemIndex = 0,
    } = product || {};
    return {
      item_name: itemName,
      item_id: itemId,
      price: '',
      discount: '',
      item_brand: '',
      item_category: itemCategory,
      item_variant: '',
      quantity: '',
      item_list_name: productListName,
      item_list_id: itemId,
      index: (itemIndex + 1),
      content_type: 'non-personalized',
      audience_type: 'non-recognized',
    };
  });

  // GA4
  addDataLayerEntry(
    eventName,
    {
      ecommerce: {
        items,
      },
      eventNonInteraction: true,
    },
  );

  // GA3
  addDataLayerEntry(Event.eec, {
    gaEvent: {
      eventCategory: productListName,
      eventAction: eventName,
      eventLabel: items,
      eventNonInteraction: true,
    },
  });
};

export enum KiyohEventAction {
  header = 'header',
}

export const dispatchDataLayerKiyohClick = (eventAction: KiyohEventAction) => addEventEntry({
  eventCategory: 'kiyoh',
  eventAction,
});
